import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
export function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToTop} className={`fixed bottom-8 right-8 z-40 p-3 bg-cg-orange-600 text-white rounded-sm shadow-lg hover:bg-cg-orange-500 transition-all duration-300 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`} aria-label="Back to top" data-id="element-26">
      <ArrowUp className="w-5 h-5" data-id="element-27" />
    </button>;
}